import { Directive, InjectionToken } from "@angular/core";

export const VDS_DIALOG_TEMPLATE = new InjectionToken<VdsDialogTemplateDirective>("VdsDialogTemplate");

@Directive({
    selector: "[vdsDialogTemplate]",
    providers: [{ provide: VDS_DIALOG_TEMPLATE, useExisting: VdsDialogTemplateDirective }]
})
export class VdsDialogTemplateDirective {}
